import { ConfirmPopup, Text } from '~/commonComponents';
import WarningIcon from '~/images/icons/Warning';
import { Colors } from '~/themes/colors';

const WarningIconComponent = () => (
  <WarningIcon width={80} height={80} color={Colors.warning_500} />
);

interface IRejectCandidateConfirmationPopupProps {
  isLoading: boolean;
  professionalName: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const RejectCandidateConfirmationPopup = ({
  isLoading,
  professionalName,
  onClose,
  onConfirm,
}: IRejectCandidateConfirmationPopupProps) => (
  // @ts-expect-error - ConfirmPopup still written in JavaScript
  <ConfirmPopup
    Icon={WarningIconComponent}
    title="Before You Continue"
    titleStyle={{ marginTop: 21, marginBottom: 20 }}
    description={
      <Text color={Colors.neutral_500}>
        This action is permanent. Once rejected,{' '}
        <Text bold color={Colors.neutral_500}>
          {professionalName}
        </Text>{' '}
        will no
        <br />
        longer be able to apply to onsite interviews for this job.
        <br />
        Do you want to continue?
      </Text>
    }
    descriptionStyle={{ width: '100%', marginBottom: 38 }}
    modalStyle={{ width: 560 }}
    leftButtonAction={onClose}
    leftButtonDisabled={isLoading}
    leftButtonText="Go Back"
    rightButtonAction={onConfirm}
    rightButtonLoading={isLoading}
    rightButtonText="Yes, Reject"
  />
);
